import { render } from "./BranchDetail.vue?vue&type=template&id=42fbb8c1&scoped=true"
import script from "./BranchDetail.vue?vue&type=script&lang=js"
export * from "./BranchDetail.vue?vue&type=script&lang=js"

import "./BranchDetail.vue?vue&type=style&index=0&id=42fbb8c1&scoped=true&lang=css"
import "./BranchDetail.vue?vue&type=style&index=1&id=42fbb8c1&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42fbb8c1"]])

export default __exports__